module.exports = __webpack_public_path__ + "static/media/shape.1bda3e02.svg";